<template>
<div id="secure">

    <section class="main-content columns is-fullheight">
        <SideMenu />
        <div class="container column is-9">
            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>

                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Leaderboard for {{ monthDisplay }} {{ actionYear }} <span class="last-refresh">Last updated on {{ lastRefresh }}</span>
                        <a href="/LeaderboardV1Full" target="_blank">
                            <font-awesome-icon icon="tv" class="header-icon" />
                        </a></p>
                        <b-select id="duration" name="duration" v-model="duration" class="header-input" @input="getLeaderboard()">
                            <option value="0">Whole Year</option>
                            <option value="1">January</option>
                            <option value="2">February</option>
                            <option value="3">March</option>
                            <option value="4">April</option>
                            <option value="5">May</option>
                            <option value="6">June</option>
                            <option value="7">July</option>
                            <option value="8">August</option>
                            <option value="9">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                            <option value="13">Ramadhan 2020</option>
                            <option value="2019">2019</option>
                            <option value="14" v-show="((schoolID == '5e6598fb9b574f0aededa6db') || (schoolID == '5c1a735fc98da061141475a1'))">Semi Final</option>
                            <option value="15" v-show="((schoolID == '5e6598fb9b574f0aededa6db') || (schoolID == '5c1a735fc98da061141475a1'))">Final</option>
                        </b-select>
                    </div>
                    <div class="card-content">

                        <div class="columns">
                            <div class="column is-half">
                                <loading :active.sync="isLoading1" 
                                    :can-cancel="false" 
                                    :is-full-page="false">
                                </loading>
                                <div class="card">
                                    <div class="card-header">
                                        <p class="card-header-title">By Students</p>
                                    </div>
                                    <div class="card-content">
                                        <div class="content">
                                            <div class="columns">    
                                                <div class="column is-one-fifth">#</div>
                                                <div class="column">Student</div>
                                                <div class="column">Class</div>
                                                <div class="column is-one-fifth">Points</div>
                                            </div>
                                            <div class="columns top-border" v-for="(top,index) in sortTop(topStudents)" :key="top._id" v-show="topStudents.length > 0">
                                                <div class="column is-one-fifth">{{ index + 1 }}</div>
                                                <div class="column">{{ top.firstName }} {{ top.lastName }}</div>
                                                <div class="column">{{ top.kelasID.level }} {{ top.kelasID.name }}</div>
                                                <div class="column is-one-fifth text-center">{{ roundTo2DecimalPlaces(top.tempNumber1) }}</div>
                                            </div>
                                            <span v-show="topStudents.length == 0" class="inline-error-message">{{ topStudentsErrorMessage }}</span>
                                        </div>
                                    </div>
                                </div>
                                <br />
                            </div>
                            <div class="column is-half">
                                <loading :active.sync="isLoading2" 
                                    :can-cancel="false" 
                                    :is-full-page="false">
                                </loading>
                                <div class="card">
                                    <div class="card-header">
                                        <p class="card-header-title">By Class</p>
                                        <div style="margin: 10px; margin-left: 0px;">
                                            <a class="button is-info is-small" style="margin-left: 5px;" v-on:click="getTopClass('excel')">Excel</a>
                                        </div>
                                    </div>
                                    <div class="card-content">
                                        <div class="content">
                                            <div class="columns">    
                                                <div class="column is-one-fifth">#</div>
                                                <div class="column">Class</div>
                                                <div class="column is-one-fifth">Points</div>
                                            </div>
                                            <div class="columns top-border" v-for="(top,index) in sortTop(topClass)" :key="top._id" v-show="topClass.length > 0">
                                                <div class="column is-one-fifth">{{ index + 1 }}</div>
                                                <div class="column">{{ top.level }} {{ top.name }}</div>
                                                <div class="column is-one-fifth text-center">{{ roundTo2DecimalPlaces(top.tempNumber1) }}</div>
                                            </div>
                                            <span v-show="topClass.length == 0" class="inline-error-message">{{ topClassErrorMessage }}</span>
                                        </div>
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
                <br />

            </div>
        </div>

    </section>    
</div>
</template>

<script>
import SideMenu from './SideMenu'
import axios from 'axios'
import "./public/style.scss";
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';


export default {
    name: "LeaderboardV1",
    components: {
        SideMenu,
        Loading,
    },
    data() {
        return {
            isLoading1: false,
            isLoading2: false,
            dateDisplay: '',
            actionDate: 0,
            actionMonth: 0,
            actionYear: 0,
            currentMonth: 0,
            duration: 1,
            monthDisplay: '',
            topStudents: [],
            topStudentsErrorMessage: '',
            topClass: [],
            topClassErrorMessage: '',
            lastRefresh: '',
            schoolID: ''
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
        console.log("before mount hoho");
    },
    created() {
        this.schoolID = localStorage.getItem('schoolID');
        var currentDate = new Date();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        this.actionYear = currentDate.getFullYear()
        var getCurrentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        this.currentMonth = getCurrentMonth
        this.duration = getCurrentMonth
        this.actionMonth = getCurrentMonth;
        if (getCurrentMonth < 10){
            getCurrentMonth = "0" + getCurrentMonth;
        }
        this.actionDate = this.actionYear + "" + getCurrentMonth + "" + currentDay;
        console.log("170 actionDate: " + this.actionDate)

        var month = currentDate.getMonth();
        var dayOfWeek = currentDate.getDay();

        var dayOfWeekDisplay = "";
        switch (dayOfWeek){
            case 0:
                dayOfWeekDisplay = "Sunday";
                break;
            case 1:
                dayOfWeekDisplay = "Monday";
                break;
            case 2:
                dayOfWeekDisplay = "Tuesday";
                break;
            case 3:
                dayOfWeekDisplay = "Wednesday";
                break;
            case 4:
                dayOfWeekDisplay = "Thursday";
                break;
            case 5:
                dayOfWeekDisplay = "Friday";
                break;
            case 6:
                dayOfWeekDisplay = "Saturday";
                break;
            default:
                dayOfWeekDisplay = "Monday";
                break;
        }

        var monthDisplay = this.getMonthDisplay(month);

        this.monthDisplay = monthDisplay;
        this.dateDisplay = dayOfWeekDisplay + ", " + currentDate.getDate() + " " + monthDisplay + " " + currentDate.getFullYear();
    },
    mounted(){
        this.getTopStudents()
        this.getTopClass('')
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        getLeaderboard(){
            this.getTopStudents()
            this.getTopClass('')
        },
        timeDifference(ts1,ts2){
            //https://stackoverflow.com/questions/16767301/calculate-difference-between-2-timestamps-using-javascript?noredirect=1&lq=1
            var difference = ts1 - ts2;

            //var daysDifference = Math.floor(difference/1000/60/60/24);
            var hoursDifference = Math.floor(difference/1000/60/60);
            //var minutesDifference = Math.floor(difference/1000/60);

            return hoursDifference;
        },
        sortTop(arrays){
            return _.orderBy(arrays, 'tempNumber1', 'desc').splice(0,100); //we're using the magical lodash function here to sort by points and return the only top 100
        },
        roundTo2DecimalPlaces(points){  //use lodash to round the points to 2 decimal places
            return _.round(points, 2)
            // return _.round(points, 2).toFixed(2)
        },
        viewClassDashboard(id,name){
            this.$store.commit('UPDATE_CLASSES_DASHBOARD_SINGLE_ID',id)
            this.$store.commit('UPDATE_CLASSES_DASHBOARD_SINGLE_NAME',name)
            localStorage.setItem('CLASSES_DASHBOARD_SINGLE_ID',id)
            localStorage.setItem('CLASSES_DASHBOARD_SINGLE_NAME',name)
            
            console.log("store.getClassesDashboardSingleID: " + this.$store.getters.getClassesDashboardSingleID);

            this.$router.push({
                name: "ClassDashboardSingle"
            });
        },
        getTopStudents(){
            let self = this;

            var show = 'all';

            if (self.duration == 0){
                show = 'all';
                self.monthDisplay = "";
            }else if (self.duration == 2019){
                console.log("235 duration 2019")
                show = 'previousYear_2019';
            }else{
                show = 'monthly'
                self.actionMonth = self.duration
                self.monthDisplay = this.getMonthDisplay(self.actionMonth - 1)  //since getMonthDisplay count starts at 0
            }
            
            var currentTS = new Date().getTime();

            if (localStorage.getItem(self.schoolID + '_leaderboard_student_monthly_' + self.actionYear + '_' + self.actionMonth)){
                //now check the item TS
                if (localStorage.getItem(self.schoolID + '_leaderboard_student_monthly_' + self.actionYear + '_' + self.actionMonth + '_ts')){
                    var prevTS = localStorage.getItem(self.schoolID + '_leaderboard_student_monthly_' + self.actionYear + '_' + self.actionMonth + '_ts');
                    var checkTimeDifference = this.timeDifference(currentTS,prevTS);
                    checkTimeDifference = 4;    //28 Aug 2019 - force get latest data
                    if (checkTimeDifference > this.$hourToCacheData){
                        console.log("dah lebih sejam, reamik")
                        this.getDataFromServer(self,show,self.actionYear,self.actionMonth)
                    }else{
                        console.log("kurang sejam, amik dari cache")

                        var dataLength = localStorage.getItem(self.schoolID + '_leaderboard_student_monthly_' + self.actionYear + '_' + self.actionMonth + '_length');
                        self.topStudents = []
                        for (var i = 0; i < dataLength; i++){
                            self.topStudents.push(JSON.parse(localStorage.getItem(self.schoolID + '_leaderboard_student_monthly_' + self.actionYear + '_' + self.actionMonth + '_' + i)))
                        }
                        self.lastRefresh = localStorage.getItem(self.schoolID + '_leaderboard_student_monthly_' + self.actionYear + '_' + self.actionMonth + '_last_refresh');
                    }
                }else{
                    console.log("no local ts, so amik dari server")
                    this.getDataFromServer(self,show,self.actionYear,self.actionMonth)
                }
            }else{               
                console.log("no local storage, so amik dari server")
                this.getDataFromServer(self,show,self.actionYear,self.actionMonth)
            }
        },           
        async getDataFromServer(self,show,actionYear,actionMonth){    
            self.isLoading1 = true;
            self.topStudents = []
            
            console.log("302 entering getTopStudents")
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.defaults.timeout = 0

            if (self.duration == 0){
                console.log("getDataFromServer for the whole current year")
                var promises = []
                for (var i = 1; i <= self.currentMonth; i++){
                    promises.push(axios.post(process.env.MY_URL + '/api/students/positive/leaderboard', {
                        params: {
                            email: localStorage.getItem('email'),
                            category: 'student',
                            show: "monthly",    //monthly since we're getting it month by month
                            limit: 20,
                            actionYear: actionYear,
                            actionMonth: i
                        }
                    }))
                }
                var yearlyLeaderboard = await Promise.all(promises)
                console.log("324 yearlyLeaderboard.length: " + yearlyLeaderboard.length)
                var topStudent;
                for (var j = 0; j < yearlyLeaderboard[0].data.content.length; j++){ //we can do this since student data should be the same throughout the loop
                    var totalPoints = 0

                    for (var k = 0; k < yearlyLeaderboard.length; k++){
                        for (var m = 0; m < yearlyLeaderboard[k].data.content.length; m++){
                            if (yearlyLeaderboard[0].data.content[j]._id == yearlyLeaderboard[k].data.content[m]._id){
                                totalPoints = totalPoints + yearlyLeaderboard[k].data.content[m].tempNumber1
                            }
                        }
                    }

                    topStudent = {
                        firstName :yearlyLeaderboard[0].data.content[j].firstName,
                        lastName :yearlyLeaderboard[0].data.content[j].lastName,
                        tempNumber1 :totalPoints,
                        kelasID: {
                            level: yearlyLeaderboard[0].data.content[j].kelasID.level,
                            name: yearlyLeaderboard[0].data.content[j].kelasID.name,
                        }
                    }
                    self.topStudents.push(topStudent)
                }
                console.log("348 before self.isLoading1 false")
                self.isLoading1 = false;
                console.log("348 AFTER self.isLoading1 false")

            }else{
                axios.post(process.env.MY_URL + '/api/students/positive/leaderboard', {
                    params: {
                        email: localStorage.getItem('email'),
                        category: 'student',
                        show: show,
                        limit: 20,
                        actionYear: actionYear,
                        actionMonth: actionMonth
                    }
                })
                .then(response => {
                    if (response.data.success){
                        var d = new Date();
                        self.lastRefresh = d.getDate() + " " + self.getMonthDisplay(d.getMonth()) + " " + d.getFullYear() + ", " + d.getHours() + ":" + d.getMinutes();
                        console.log("responseee")
                        localStorage.setItem(self.schoolID + '_leaderboard_student_monthly_' + actionYear + '_' + actionMonth,"OK")
                        localStorage.setItem(self.schoolID + '_leaderboard_student_monthly_' + actionYear + '_' + actionMonth + '_ts',Date.now())
                        localStorage.setItem(self.schoolID + '_leaderboard_student_monthly_' + actionYear + '_' + actionMonth + '_last_refresh',self.lastRefresh)
                        localStorage.setItem(self.schoolID + '_leaderboard_student_monthly_' + actionYear + '_' + actionMonth + "_length",response.data.content.length)
                        for (var i = 0; i < response.data.content.length; i++){
                            const parsed = JSON.stringify(response.data.content[i]);
                            localStorage.setItem(self.schoolID + '_leaderboard_student_monthly_' + actionYear + '_' + actionMonth + '_' + i, parsed);
                        }
                        self.topStudents = response.data.content
                    }else{
                        self.topStudentsErrorMessage = response.data.msg
                        self.topStudents = []
                    }
                    self.isLoading1 = false
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading1 = false
                })
            }
                
        },
        getTopClass(output){
            let self = this;
            this.isLoading2= true;

            var show = 'all';

            if (self.duration == 0){
                show = 'all';
                self.actionMonth = self.duration
            }else if (self.duration == 2019){
                console.log("235 duration 2019")
                show = 'previousYear_2019';
            }else{
                show = 'monthly'
                self.actionMonth = self.duration
            }

            if (output == "excel"){
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'blob'
                axios.defaults.timeout = 0
                axios.post(process.env.MY_URL + '/api/students/positive/leaderboard', {
                        params: {
                            email: localStorage.getItem('email'),
                            category: 'school',
                            show: show,
                            limit: 20,
                            actionYear: self.actionYear,
                            actionMonth: self.actionMonth,
                            output: 'excel'
                        }
                    })
                   .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', "School Leaderboard_" + self.getMonthDisplay(self.actionMonth - 1) + "_" + self.actionYear + ".xlsx"); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        self.isLoading2 = false;

                    })
                    .catch(e => {
                        console.log(e)
                        self.isLoading2 = false
                    })
            }else{
                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'
                axios.defaults.timeout = 0
                axios.post(process.env.MY_URL + '/api/students/positive/leaderboard', {
                        params: {
                            email: localStorage.getItem('email'),
                            category: 'school',
                            show: show,
                            limit: 20,
                            actionYear: self.actionYear,
                            actionMonth: self.actionMonth,
                            output: ''
                        }
                    })
                    .then(response => {
                        if (response.data.success == false){
                            self.topClassErrorMessage = response.data.msg
                            self.topClass = []
                        }else{
                            self.topClass = response.data
                        }
                        self.isLoading2 = false
                    })
                    .catch(e => {
                        console.log(e)
                        self.isLoading2 = false
                    })
            }
        },
        goDbKelas() {
            this.$router.push({
                name: "KelasMain"
            });
        },
        getMonthDisplay(month){
            month = parseInt(month)
            var monthDisplay = "";
            switch (month){
                case 0:
                    monthDisplay = "January";
                    break;
                case 1:
                    monthDisplay = "February";
                    break;
                case 2:
                    monthDisplay = "March";
                    break;
                case 3:
                    monthDisplay = "April";
                    break;
                case 4:
                    monthDisplay = "May";
                    break;
                case 5:
                    monthDisplay = "June";
                    break;
                case 6:
                    monthDisplay = "July";
                    break;
                case 7:
                    monthDisplay = "August";
                    break;
                case 8:
                    monthDisplay = "September";
                    break;
                case 9:
                    monthDisplay = "October";
                    break;
                case 10:
                    monthDisplay = "November";
                    break;
                case 11:
                    monthDisplay = "December";
                    break;
                case 12:
                    monthDisplay = "Ramadhan";
                    break;
                default:
                    monthDisplay = "";
                    break;
            }
            return monthDisplay;
        }
    }
};
</script>

<style scoped>
.kelas-button{
    margin-right: 10px;
    margin-bottom: 10px;
}
.header-tag{
    float: right !important;
    border: 1px solid #209cee;
    color: #209cee;
    padding-bottom: calc(0.375em - 1px);
    padding-left: 0.75em;
    padding-right: 0.75em;
    padding-top: calc(0.375em - 1px);
    align-items: center;
    border-radius: 4px;
    font-size: 1rem;
    height: 2.25em;
    line-height: 1.5;
    margin: 10px;
}
.header-date{
    float: right;
    padding: 10px;
}
.attendance-pie{
    width: 250px;
    height: 250px;
}
.header-input{
    margin: 10px;
}
.header-icon{
    margin: 5px;
}
.last-refresh{
    font-weight: normal;
    font-size: 0.9rem;
    font-style: italic;
    margin-left:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/LeaderboardV1.vue